import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

import {
  usePlanzonePermissions,
  useProjectPermissions,
} from "@components/permissions";
import { Props } from "./types";
import { ListIcon } from "./listIcon";
import { GanttIcon } from "./ganttIcon";
import { KanbanIcon } from "./kanbanIcon";
import { SynthesisIcon } from "./synthesisIcon";
import { TimeSheetIcon } from "./timeSheetIcon";
import { CalendarIcon } from "./calendarIcon";
import classNames from "classnames";
import styles from "./styles.scss";

function Navigation({ project, config }: Props) {
  const { t } = useTranslation();
  const { isAdministrator } = usePlanzonePermissions();
  const { isProjectManager } = useProjectPermissions(project);

  return (
    <ul className={styles.navigation}>
      {config.isSynthesisEnabled && !project.isTemplate && (
        <li className={styles.item}>
          <NavLink
            to={`/projects/${project.uuid}`}
            className={({ isActive }) =>
              classNames(styles.link, { [styles.selectedLink]: isActive })
            }
            end
          >
            <SynthesisIcon className={styles.icon} />
            <p className={styles.text}>{t("zonePage.navigation.synthesis")}</p>
          </NavLink>
        </li>
      )}
      {config.isListsListEnabled && (
        <li className={styles.item}>
          <NavLink
            to={`/projects/${project.uuid}/lists`}
            className={({ isActive }) =>
              classNames(styles.link, { [styles.selectedLink]: isActive })
            }
          >
            <ListIcon className={styles.icon} />
            <p className={styles.text}>{t("zonePage.navigation.list")}</p>
          </NavLink>
        </li>
      )}
      {config.isGanttEnabled && (
        <li className={styles.item}>
          <NavLink
            to={`/projects/${project.uuid}/gantt`}
            className={({ isActive }) =>
              classNames(styles.link, { [styles.selectedLink]: isActive })
            }
          >
            <GanttIcon className={styles.icon} />
            <p className={styles.text}>{t("zonePage.navigation.gantt")}</p>
          </NavLink>
        </li>
      )}
      {config.isCalendarEnabled && !project.isTemplate && (
        <li className={styles.item}>
          <NavLink
            to={`/projects/${project.uuid}/calendar`}
            className={({ isActive }) =>
              classNames(styles.link, {
                [styles.selectedLink]: isActive,
              })
            }
          >
            <CalendarIcon className={styles.icon} />
            <p className={styles.text}>{t("zonePage.navigation.calendar")}</p>
          </NavLink>
        </li>
      )}
      {config.isBoardEnabled && (
        <li className={styles.item}>
          <NavLink
            to={`/projects/${project.uuid}/kanban`}
            className={({ isActive }) =>
              classNames(styles.link, { [styles.selectedLink]: isActive })
            }
          >
            <KanbanIcon className={styles.icon} />
            <p className={styles.text}>{t("zonePage.navigation.kanban")}</p>
          </NavLink>
        </li>
      )}
      {config.areTimeSheetsEnabled &&
        (isAdministrator || isProjectManager) &&
        !project.isTemplate && (
          <li className={styles.item}>
            <NavLink
              to={`/projects/${project.uuid}/time-sheets`}
              className={({ isActive }) =>
                classNames(styles.link, styles.timeSheets, {
                  [styles.selectedLink]: isActive,
                })
              }
            >
              <TimeSheetIcon className={styles.icon} />
              <p className={styles.text}>
                {t("zonePage.navigation.timeSheets")}
              </p>
            </NavLink>
          </li>
        )}
    </ul>
  );
}

export { Navigation };
